import ABDM from "./ABDMConstants";
// ============================================================
// GENERIC STORAGE
// ============================================================
const Storage = {
    // ========================================================
    // SET
    // ========================================================
    set(key, value) {
        if (value === undefined || value === null) {
            return;
        }
        if (typeof value === "object") {
            localStorage.setItem(key, JSON.stringify(value));
        } else {
            localStorage.setItem(key, value);
        }
    }, // ========================================================
    // GET
    // ========================================================
    get(key) {
        const value = localStorage.getItem(key);
        if (!value) {
            return null;
        }
        try {
            return JSON.parse(value);
        } catch {
            return value;
        }
    }, // ========================================================
    // REMOVE
    // ========================================================
    remove(key) {
        localStorage.removeItem(key);
    }, // ========================================================
    // CLEAR
    // ========================================================
    clear() {
        Object.values(ABDM).forEach(key => {
            localStorage.removeItem(key);
        });
    }
};
// ============================================================
// TOKEN STORAGE
// ============================================================
const TokenStorage = {
    // ========================================================
    // ACCESS TOKEN
    // ========================================================
    saveAccessToken(token) {
        Storage.set(ABDM.ACCESS_TOKEN, token);
    }, getAccessToken() {
        return Storage.get(ABDM.ACCESS_TOKEN);
    }, // ========================================================
    // X TOKEN
    // ========================================================
    saveXToken(token) {
        Storage.set(ABDM.X_TOKEN, token);
    }, getXToken() {
        return Storage.get(ABDM.X_TOKEN);
    }, // ========================================================
    // T TOKEN
    // ========================================================
    saveTToken(token) {
        Storage.set(ABDM.T_TOKEN, token);
    }, getTToken() {
        return Storage.get(ABDM.T_TOKEN);
    }, // ========================================================
    // TXN ID
    // ========================================================
    saveTxnId(txnId) {
        Storage.set(ABDM.TXN_ID, txnId);
    }, getTxnId() {
        return Storage.get(ABDM.TXN_ID);
    }, // ========================================================
    // ABHA NUMBER
    // ========================================================
    saveAbhaNumber(number) {
        Storage.set(ABDM.ABHA_NUMBER, number);
    }, getAbhaNumber() {
        return Storage.get(ABDM.ABHA_NUMBER);
    }, // ========================================================
    // ABHA ADDRESS
    // ========================================================
    saveAbhaAddress(address) {
        Storage.set(ABDM.ABHA_ADDRESS, address);
    }, getAbhaAddress() {
        return Storage.get(ABDM.ABHA_ADDRESS);
    }, // ========================================================
    // PROFILE
    // ========================================================
    saveProfile(profile) {
        Storage.set(ABDM.PROFILE, profile);
    }, getProfile() {
        return Storage.get(ABDM.PROFILE);
    }, // ========================================================
    // CLEAR
    // ========================================================
    clear() {
        Storage.clear();
    }
};
export default TokenStorage;